import Button from '../../../components/Button'
import Layout from '../../../components/Layout'
import OutgoingPayment from '../OutgoingPayment'
import { useNavigate } from 'react-router-dom'
import api from '../../../api'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ClipLoader } from 'react-spinners'
import { BG_COLOR } from '../../../constants/colors'

export default function SentJournalEntries() {
	const navigate = useNavigate()
	const today = new Date().toISOString().split('T')[0]
	const { getMe } = useSelector((state) => state.main)
	const [data, setData] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const [skip, setSkip] = useState(0)
	const [startDate, setStartDate] = useState(today)
	const [endDate, setEndDate] = useState(today)

	useEffect(() => {
		;(async () => {
			setIsLoading(true)
			try {
				const response = await api.get('/DraftJournalEntry', {
					params: {
						$filter: `U_Sender eq ${getMe?.EmployeeID} and CreateDate ge '${startDate}T00:00:00Z' and CreateDate le '${endDate}T23:59:59Z'`,
						$select: 'U_Sender,U_Receiver,CreateDate,JOURNALENTRYRCollection',
						$skip: skip,
						$top: 20,
					},
					headers: {
						Prefer: 'odata.maxpagesize=100000',
					},
				})
				const resData = JSON.parse(response.data).value
				// console.log(resData)

				setData(resData)
			} catch (error) {
				console.log(error)
			} finally {
				setIsLoading(false)
			}
		})()
	}, [startDate, endDate, getMe?.EmployeeID, skip])

	return (
		<Layout>
			<OutgoingPayment
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div className="container">
					<p className="productTitle">Отправлено денег из кассы</p>
					<div className="flex flex-row items-center justify-between my-4">
						<div className="flex flex-row gap-4 justify-start items-center">
							<div className="flex flex-col">
								<span className="text-sm text-gray-500 mb-2">Дата начала</span>
								<input
									type="date"
									className={
										'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full'
									}
									value={startDate}
									onChange={(e) => setStartDate(e.target.value)}
								/>
							</div>
							<div className="flex flex-col">
								<span className="text-sm text-gray-500 mb-2">
									Дата окончания
								</span>
								<input
									type="date"
									className={
										'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full'
									}
									value={endDate}
									onChange={(e) => setEndDate(e.target.value)}
								/>
							</div>
						</div>
						<div className="flex flex-row justify-end items-center gap-4">
							<Button
								btnStyle={{ width: 'max-content', padding: '0 10px' }}
								onClick={() => navigate('/create-draft-journal-entries')}
							>
								Добавить
							</Button>
						</div>
					</div>
					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
							<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
								<tr>
									<th scope="col" className="px-6 py-4">
										Дата
									</th>
									<th scope="col" className="px-6 py-4">
										C кассы
									</th>
									<th scope="col" className="px-6 py-4">
										На сейф
									</th>
									<th scope="col" className="px-6 py-4">
										Сумма
									</th>
									<th scope="col" className="px-6 py-4">
										Валюта
									</th>
									<th scope="col" className="px-6 py-4">
										Комментарий
									</th>
									<th scope="col" className="px-6 py-4">
										Подтверждение
									</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => {
									return (
										<tr
											className="bg-white border-b  hover:bg-gray-50 "
											key={index}
										>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_Date.split('T')[0]}
											</td>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_FromAccount}
											</td>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_ToAccount}
											</td>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_PaidSum}
											</td>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_Currency}
											</td>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_Comment}
											</td>
											<td className="px-6 py-4">
												{item.JOURNALENTRYRCollection[0].U_Sent === 'Yes' &&
												item.JOURNALENTRYRCollection[0].U_Received === 'Yes'
													? 'Да'
													: 'Нет'}
											</td>
										</tr>
									)
								})}
								{/* {data.data.map((v, i) => {
										const accCode = get(
											v.JournalEntryLines[0],
											'AccountCode',
											'',
										)
										const accName = cashAccountsData.find(
											(item) => item.Code == accCode,
										)?.Name
										const contrAccCode = get(
											v.JournalEntryLines[0],
											'ContraAccount',
											'',
										)
										const contrAccName = cashAccountsData.find(
											(item) => item.Code == contrAccCode,
										)?.Name

										return (
											<tr
												className="bg-white border-b  hover:bg-gray-50 "
												key={i}
											>
												<td className="px-6 py-4">
													{moment(get(v, 'ReferenceDate', '')).format(
														'DD-MM-YYYY',
													)}
												</td>
												<td className="px-6 py-4 whitespace-nowrap">
													{`${contrAccCode} - ${contrAccName}`}
												</td>
												<td className="px-6 py-4">
													{`${accCode} - ${accName}`}
												</td>
												<td className="px-6 py-4">
													{get(v.JournalEntryLines[0], 'FCCurrency', '') ===
													'UZS'
														? formatNumberWithIntl(
																get(v.JournalEntryLines[0], 'FCDebit', ''),
															)
														: formatNumberWithIntl(
																get(v.JournalEntryLines[0], 'Debit', ''),
															)}
												</td>
												<td className="px-6 py-4">
													{get(v.JournalEntryLines[0], 'FCCurrency', '') ||
														'USD'}
												</td>

												<td className="px-6 py-4">{get(v, 'Memo', '')}</td>
											</tr>
										)
									})} */}
							</tbody>
						</table>
					)}
					<div className="topCard">
						<div style={{ alignItems: 'center' }} className="flex">
							<Button
								onClick={() => {
									if (skip > 0) {
										setSkip(skip - 20)
									}
								}}
								btnStyle={{ marginRight: 10 }}
								disabled={skip === 0}
							>
								{'<'}
							</Button>
							<p style={{ marginRight: '10px' }}>
								{Math.ceil((skip + 1) / 20)}
							</p>
							<Button
								onClick={() => {
									if (data.length === 20) {
										setSkip(skip + 20)
									}
								}}
								disabled={data.length < 20}
							>
								{'>'}
							</Button>
						</div>
					</div>
				</div>
			</OutgoingPayment>
		</Layout>
	)
}
